<template>
<div id="" class="pb100">
  <v-container v-if="contest">
    <v-row justify="center">
      <v-col cols="12" sm="12" md="12" lg="12" xl="9">
        <v-card>
          <div class="video-responsive">
            <iframe :src="videoIframe" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" autoplay allowfullscreen></iframe>
          </div>


          <v-card-title class="secondary white--text">
            <h5>Contest details</h5>
            <v-spacer></v-spacer>
            <h5><v-icon class="mr-2" small :color="contest.status===1 ? 'green' : 'red' " dark>fa-circle</v-icon> {{contest.status===1 ? 'Open' : 'Closed'}}</h5>
          </v-card-title>


          <v-container fluid class="">
            <v-row align="end" justify="space-between">
              <v-col cols="12" md="6" lg="7" class="">
                <v-row>

                  <v-col cols="12">
                    <v-card dark color="secondary" :style="gradientStyle(contest.gradients.contest_by.color_1,contest.gradients.contest_by.color_2)">

                      <v-card-text class="white--text pt-2 pb-0">
                        <span class="title">Contest by</span>
                      </v-card-text>
                      <v-card-subtitle class="pt-0 pb-2">
                        {{contest.brand_name}}
                      </v-card-subtitle>


                    </v-card>
                  </v-col>

                  <v-col cols="12">
                    <v-card dark color="secondary" :style="gradientStyle(contest.gradients.talk_about.color_1,contest.gradients.talk_about.color_2)">

                      <v-card-text class="white--text pt-2 pb-0">
                        <span class="title">Talk about</span>
                      </v-card-text>
                      <v-card-subtitle class="pt-0 pb-2">
                        {{contest.talk_about}}
                      </v-card-subtitle>


                    </v-card>
                  </v-col>

                  <v-col cols="12">
                    <v-card dark color="secondary" :style="gradientStyle(contest.gradients.challenge.color_1,contest.gradients.challenge.color_2)">

                      <v-card-text class="white--text pt-2 pb-0">
                        <span class="title">Challenge</span>
                      </v-card-text>
                      <v-card-subtitle class="pt-0 pb-2">
                        {{contest.notes}}
                      </v-card-subtitle>


                    </v-card>
                  </v-col>

                  <v-col cols="12">
                    <v-card dark color="secondary" :style="gradientStyle(contest.gradients.rank_requirement.color_1,contest.gradients.rank_requirement.color_2)">
                      <v-card-text class="white--text pt-2 pb-0">
                        <span class="title">Rank requirement</span>
                      </v-card-text>
                      <v-card-subtitle class="pt-0 pb-2">
                        <span v-if="contest.min_rank>1">Open to rank {{contest.min_rank}} and up</span>
                        <span v-else>Open to all ranks</span>
                      </v-card-subtitle>
                    </v-card>
                  </v-col>

                  <v-col cols="12" v-if="contest.deadline">
                    <v-card dark color="secondary" :style="gradientStyle(contest.gradients.deadline.color_1,contest.gradients.deadline.color_2)">
                      <v-card-text class="white--text pt-2 pb-0">
                        <span class="title">Closing date</span>
                      </v-card-text>
                      <v-card-subtitle class="pt-0 pb-2">
                        <span>{{contest.deadline | dateFormat}}</span>
                      </v-card-subtitle>

                    </v-card>
                  </v-col>

                </v-row>
              </v-col>
              <v-col cols="12" md="6" lg="5">
                <v-container class="py-0">
                  <v-row>
                    <v-col cols="12" class="text-center py-0">
                      <v-card-subtitle class="pt-3 pb-0">
                        Prize
                      </v-card-subtitle>
                      <v-card-text class="pt-0 pb-2">
                        <span class="title">{{contest.prize}}</span>
                      </v-card-text>
                    </v-col>
                    <v-col cols="12" class="pt-0">
                      <div class="">
                        <img :src="contest.prize_image" style="width:100%;height:auto" />
                      </div>
                    </v-col>

                    <v-col cols="12" v-if="contest.project_bonus>0">
                      <v-card dark color="secondary" :style="gradientStyle(contest.gradients.bonus.color_1,contest.gradients.bonus.color_2)">
                        <v-card-text class="white--text pt-2 pb-0">
                          <span class="title">Bonus to Top 3</span>
                        </v-card-text>
                        <v-card-subtitle class="pt-0 pb-2">
                          ${{contest.project_bonus}}/person
                        </v-card-subtitle>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>

              </v-col>

            </v-row>
          </v-container>

          <v-card-actions class="grey lighten-3 py-4">
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                      <v-btn icon  v-on="on" @click="$store.getters['account/isLoggedIn'] ?  $store.dispatch('account/toggle_bookmark',contest.id) : loginRequired() ">
                        <v-icon  v-if="contest.bookmarked" color="orange">fas fa-bookmark</v-icon>
                        <v-icon  v-else  color="orange">far fa-bookmark</v-icon>
                      </v-btn>
                    </template>
              <span v-if="contest.bookmarked">Bookmarked</span>
              <span v-else>Bookmark</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="submitToContest" :disabled="contest.status!==1" v-if="!$store.getters['account/isBusiness']">Enter contest</v-btn>
          </v-card-actions>
        </v-card>

      </v-col>

    </v-row>
  </v-container>
</div>
</template>
<script>
export default {
  name: "",
  data: () => ({
    version: 2
  }),
  created() {

  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$store.dispatch('contests/load_contest', to.params.id)
    })
  },
  beforeRouteUpdate(to, from, next) {
    this.$store.dispatch('contests/load_contest', to.params.id)
    next()
  },
  methods: {
    gradientStyle(color_1, color_2) {
      return `background: ${color_1};background: -webkit-linear-gradient(to right, ${color_1}, ${color_2});background: linear-gradient(to right, ${color_1}, ${color_2});`
    },
    loginRequired() {
      this.$store.commit('account/set_continue', this.$route)
      this.$router.push({
        path: '/login'
      })
    },
    submitToContest() {
      this.$router.push({
        path: '/user/projects/create',
        query: {
          contest_id: this.contest.id
        }
      })
    }
  },
  computed: {
    contest() {
      return this.$store.getters['contests/loadedContest']
    },
    videoIframe() {
      return this.$helpers.iframeFromUrl(this.contest.promo_video_url)
    }
  }
}
</script>
<style lang="scss" scoped>
.video-responsive {
    overflow: hidden;
    padding-bottom: 56.25%;
    position: relative;
    height: 0;
}
.video-responsive iframe {
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    position: absolute;
}
</style>
